import * as tslib_1 from "tslib";
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ConfigService } from './../config/config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../config/config.service";
export class VentabonosService {
    constructor(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.headers = new HttpHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
        });
    }
    getPrestadores(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/ComprarBono/ObtenerPrestadores`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getLugaresAtencion(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/ComprarBono/BuscarLugaresAtencion`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getRegiones() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/Regiones/GetRegiones`;
            try {
                return yield this.httpClient.get(url).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getComunas(codRegion) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/Regiones/GetComunasRegion?codRegion=${codRegion}`;
            try {
                return yield this.httpClient.get(url).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    valorizarBono(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/ComprarBono/ValorizarBono`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    emitirBono(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/ComprarBono/EmitirBonoVentaWeb`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    registrarBono(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/ComprarBono/RegistrarPago`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    obtenerBono(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/ComprarBono/ObtenerBonoB64`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    consultarBono(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/ComprarBono/ConsultarBonoRut`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getExcedentes(marca) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rut = localStorage.getItem('cbRutCliente');
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/ComprarBono/ObtenerExcedentes`;
            const data = { rutCotizante: Number(rut), marca };
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (_a) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
}
VentabonosService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VentabonosService_Factory() { return new VentabonosService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: VentabonosService, providedIn: "root" });
